import { Button, CircleX, Trash2 } from "../../../ui";

// "Select to delete" → "Delete (n)" / "Cancel" controls shared by all sections.
export default function DeleteSelectionToolbar({
  selection,
  lang,
  permanent = false,
  className = "lud-delete-toolbar",
  onStart,
}) {
  const ar = lang === "ar";
  const count = selection.selected.length;

  return (
    <div className={className}>
      {!selection.active ? (
        <Button
          variant="danger"
          appearance="soft"
          icon={<Trash2 size={17} />}
          onClick={onStart || selection.start}
        >
          {permanent
            ? ar
              ? "تحديد للحذف النهائي"
              : "Select for permanent delete"
            : ar
              ? "تحديد للحذف"
              : "Select to delete"}
        </Button>
      ) : (
        <>
          {count > 0 && (
            <Button
              variant="danger"
              appearance="filled"
              icon={<Trash2 size={17} />}
              onClick={selection.openConfirm}
              disabled={selection.deleting}
            >
              {permanent
                ? ar
                  ? `حذف نهائي (${count})`
                  : `Permanent delete (${count})`
                : ar
                  ? `حذف (${count})`
                  : `Delete (${count})`}
            </Button>
          )}
          <Button
            variant="danger"
            appearance="soft"
            icon={<CircleX size={17} />}
            onClick={selection.cancel}
            disabled={selection.deleting}
          >
            {ar ? "إلغاء" : "Cancel"}
          </Button>
        </>
      )}
    </div>
  );
}
